import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee, faBriefcase } from '@fortawesome/free-solid-svg-icons';

library.add(faCoffee);
library.add(faBriefcase);
